import { UpdateSecurityTypeRequest } from '../../../../web-api-client';
import { SecurityType } from '../../models';

export const mapSecurityTypeToUpdateRequest = (
  securityType: SecurityType
): UpdateSecurityTypeRequest => {
  return new UpdateSecurityTypeRequest({
    securityTypeId: securityType.securityTypeId,
    name: securityType.name,
    isActive: securityType.isActive,
    parentSecurityTypeId: securityType.parentSecurityTypeId,
    isParent: securityType.isParent,
  });
};
